import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import landingPageService from './landingpageService'


const initialState = {
    landingPage: [],
    landingStatus: false,
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: ''
}


//Get resources

export const getLandingPage = createAsyncThunk('landingpage/getAll', async (_, thunkAPI) => {
    
        try {
            // const token = thunkAPI.getState().auth.user.token;
            // alert("hello")
            return await landingPageService.getLandingPage();
        } catch (error) {
            const message  = (error.response && error.response.data && error.response.data.message) || error.message || error.toString() 
            return thunkAPI.rejectWithValue(message);
        }
})



export const landingPageSlice = createSlice({
    name: "landingPage",
    initialState,
    reducers: {
        reset: (state) => initialState 
    },
    extraReducers: (builder) => {
        builder
       
    .addCase(getLandingPage.pending, (state) => {
        state.isLoading = true;
})
    .addCase(getLandingPage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.landingPage = action?.payload?.data
        // state.resources = action.payload
        // console.log(action.payload.data)
        
})

    .addCase(getLandingPage.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
})

}

}) 


export const {reset} = landingPageSlice.actions;
export default landingPageSlice.reducer;